/**
 * Touch drag of table rows (U74): a long press on a row's grip starts dragging; the finger may
 * not move further than the tolerance before (otherwise it scrolls). Dropping on the stage places
 * the rows (canvas drop event), on another row of the same table moves them there.
 */

/** Hold time before a touch on the grip becomes a drag. */
export const LONG_PRESS_MS = 400;
/** Movement (px) that cancels the long press. */
export const MOVE_TOLERANCE = 8;

/** Custom DOM event the canvas listens to: a row drop at screen coordinates. */
export const CANVAS_DROP_EVENT = 'stageplottter:canvas-drop';

export interface CanvasDropDetail {
  mime: string;
  data: string;
  clientX: number;
  clientY: number;
}

/** True when the finger moved too far for a long press. */
export function movedTooFar(
  start: { x: number; y: number },
  now: { x: number; y: number },
): boolean {
  return Math.hypot(now.x - start.x, now.y - start.y) > MOVE_TOLERANCE;
}

/**
 * Steps (±1 moves via `onMoveRows`) that bring the dragged rows to the target row: the distance
 * from the first dragged row to the target in the current order; 0 when the target is one of
 * them or unknown.
 */
export function moveSteps(
  order: readonly string[],
  keys: readonly string[],
  targetKey: string,
): number {
  if (keys.includes(targetKey)) return 0;
  const target = order.indexOf(targetKey);
  const first = order.findIndex((k) => keys.includes(k));
  if (target < 0 || first < 0) return 0;
  const last = order.length - 1 - [...order].reverse().findIndex((k) => keys.includes(k));
  // moving down: the block's last row ends at the target; up: its first row starts there
  return target > first ? target - last : target - first;
}
